export default __webpack_public_path__ + "static/media/MACFL.3d14d65c.png";